import { Text, ITextProps } from '@fluentui/react';

export const ButtonText = ({ children }: { children: React.ReactNode; }) => <Text styles={commanbarItemStyles}>{children}</Text>;
const commanbarItemStyles: ITextProps['styles'] = { root: { width: '100%', height: '100%', display: 'flex' } };
